import React from "react";
import { Container, Nav, Button, Row, Col, Form, Image } from "react-bootstrap";

import { Link as LinkRoll } from "react-scroll";
import logofoot from "../../../assets/logofoot.svg";
import facebook from "../../../assets/facebook.svg";
import instagram from "../../../assets/instagram.svg";
import linkedin from "../../../assets/linkedin.svg";
import twitter from "../../../assets/twitter.svg";
import "../../homepage/homepage.css";
import { Link } from "react-router-dom";
import { ExternalLink } from "react-external-link";
import AppStoreSvg from "../component/ButtonComponents/appstore";
import PlayStoreSvg from "../component/ButtonComponents/playstore";
import { Links } from "../../Links";

function FooterSection() {
  const buttonNav = {
    backgroundColor: "#F5F6F7",
  };

  return (
    <Container fluid className="Bottomnav" style={buttonNav}>
      <Row>
        <Col sm={12} md={12} lg={5} xl={5}>
          <div>
            <Nav.Link>
              <LinkRoll
                to="hero"
                spy={true}
                smooth={true}
                offset={-70}
                duration={100}
              >
                <Image src={logofoot} fluid />
              </LinkRoll>
            </Nav.Link>
            <p className="bottomparagraph">
            Welcome to Lodapoint <br/>Your go-to platform for all things logistics. 
            We are here to make shipping easy for everyone whether you are a sender 
            needing to send cargo, a transporter looking to maximize your fleet, or a 
            driver seeking new opportunities. Join us and discover how simple logistics 
            can be!
            </p>

            <div className="downloadbtn">
              <Button
                variant="primary"

                href={Links.User.playStore}
                target="_blank"
                 rel="noopener noreferrer"

                style={{
                  backgroundColor: "#343938",
                  borderColor: "#313434",
                  borderRadius: 36 + "px",
                  paddingTop: 7+"px",
                }}

                className="buttondownload"
                size="sm"
              >
                <PlayStoreSvg />
              </Button>
              <Button
                variant="primary"

                 href={Links.User.appStore}
                target="_blank"
                 rel="noopener noreferrer"

                style={{
                  backgroundColor: "#343938",
                  borderColor: "#313434",
                  color: "#FFFFF",
                  borderRadius: 36 + "px",
                  paddingTop: 7+"px",
                }}
                className="buttondownload"
                size="sm"
              >
                <AppStoreSvg />
              </Button>
            </div>
            
            
          </div>
          <br />
        </Col>
        <Col sm={12} md={12} lg={7} xl={7}>
          <Row>
            <Col sm={6} md={4} lg={4} xl={4}>
              <div className="navlinkingclass">
                <div
                  style={{
                    color: "#5C5571",
                    fontSize: 0.8 + "rem",
                    listStyle: "none",
                  }}
                >
                  <h4
                    style={{
                      color: "#F36F2E",
                      fontSize: 0.9 + "rem",
                      fontWeight: "600",
                    }}
                  >
                    PRODUCTS
                  </h4>
                  <li>Rider/Sender</li>
                  <li>Driver</li>
                  <li>Transporter</li>
                </div>
              </div>
            </Col>

            <Col sm={6} md={4} lg={4} xl={4}>
              <div className="navlinkingclass">
                <div
                  style={{
                    color: "#5C5571",
                    fontSize: 0.8 + "rem",
                    listStyle: "none",
                  }}
                >
                  <h4
                    style={{
                      color: "#F36F2E",
                      fontSize: 0.9 + "rem",
                      fontWeight: "600",
                    }}
                  >
                    COMPANY
                  </h4>
                  <li>
                    <Link style={{ color: "#5C5571" }} to="/blog">
                      Our Blog
                    </Link>
                  </li>
                  <li>
                    <Link style={{ color: "#5C5571" }} to="/aboutus">
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link style={{ color: "#5C5571" }} to="/career">
                      Career
                    </Link>
                  </li>
                  <li>
                    <Link style={{ color: "#5C5571" }} to="/privacy">
                      Privacy & Terms
                    </Link>
                  </li>

                </div>
              </div>
            </Col>

            <Col sm={6} md={4} lg={4} xl={4}>
              <div className="navlinkingclass">
                <div
                  style={{
                    color: "#5C5571",
                    fontSize: 0.8 + "rem",
                    listStyle: "none",
                  }}
                >
                  <h4
                    style={{
                      color: "#F36F2E",
                      fontSize: 0.9 + "rem",
                      fontWeight: "600",
                    }}
                  >
                    HELP
                  </h4>
                  <li>
                    <Link style={{ color: "#5C5571" }} to="/faqs">
                      FAQs
                    </Link>
                  </li>
                  <li>
                    <Link style={{ color: "#5C5571" }} to="/safety">
                      Safety
                    </Link>
                  </li>
                  <li>
                    <Link style={{ color: "#5C5571" }} to="/contactus">
                      Contact us
                    </Link>
                  </li>
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <br />

      <Row>
        <Col sm={12} md={12} lg={5} xl={5}>
          <div>
            <p className="bottomparagraph">
              Join our vibrant community across social media platforms! From
              exciting updates to exclusive offers, we are always here to
              connect, engage, and support you on your journey with us
            </p>

            <div style={{ display: "flex" }}>

            <ExternalLink href="https://www.facebook.com/profile.php?id=61558344101439&mibextid=LQQJ4d">
              <Image
                style={{ marginRight: 0.3 + "rem" }}
                src={facebook}
                fluid
              />
              </ExternalLink>

              <ExternalLink href="https://www.instagram.com/Theloda.co">
              <Image style={{ marginRight: 0.3 + "rem" }} src={instagram} fluid />
              </ExternalLink>

              <ExternalLink href="https://www.linkedin.com/">
              <Image
                style={{ marginRight: 0.3 + "rem" }}
                src={linkedin}
                fluid
              />
              </ExternalLink>

              <ExternalLink href="https://twitter.com/Theloda_">
              <Image style={{ marginRight: 0.3 + "rem" }} src={twitter} fluid />
              </ExternalLink>

            </div>
          </div>
        </Col>
        <Col sm={12} md={12} lg={2} xl={2}></Col>

        <Col sm={12} md={12} lg={5} xl={5}>
          <div className="newsletterformbody">
            <h6 className="newsletterhead">Join Our Newsletter</h6>
            <div
              style={{
                display: "flex",
                backgroundColor: "white",
                borderRadius: 36 + "PX",
              }}
            >
              <Form.Control
                style={{
                  height: 2.7 + "rem",
                  fontFamily: "jost, sans-serif",
                  fontSize: 0.85 + "rem",
                  borderRadius: 36 + "PX",
                }}
                type="email"
                placeholder="Enter your mail here"
              />
              <Button
                style={{
                  height: 2.7 + "rem",
                  marginTop: 0 + "rem",
                  fontFamily: "jost, sans-serif",
                  backgroundColor: "#F36F2E",
                  borderRadius: 36 + "PX",
                  paddingLeft: 1.2 + "rem",
                  paddingRight: 1.2 + "rem",
                }}
                variant="primary"
                className="button-store"
                type="submit"
              >
                Subscribe
              </Button>
            </div>
            <p
              className="newsletterparagraph"
              style={{ marginTop: 0.7 + "rem" }}
            >
              * Will send you weekly updates for your better engagement.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default FooterSection;
